<template>
	<div>
		<el-dialog title="添加支付宝" :visible.sync="dialogFormVisible">
			<div class="userform" style="padding: 0;" >
				<div class="form-group mb0">
					<label class="form-label">支付宝姓名：</label>
					<div class="form-element"><strong>{{name}}</strong></div>
				</div>
						<div class="form-group">
							<label class="form-label">
								<em>*</em>
								 支付宝帐号：
							</label>
							<div class="form-element">
								<input class="form-control"  type="text" v-model="addZfbAccount" placeholder="请输入支付宝账号"/>
								<div class="help-block">
									<p>
										请认真填写，该支付宝账户真实姓名必须与【
										<span class="text-dark">{{name}}</span>
										】身份一致！
									</p>
								</div>
							</div>
						</div>
						<div class="form-group">
							<label class="form-label">
								<em>*</em>
									确认帐号：
							</label>
							<div class="form-element">
								<input class="form-control" v-model="addZfbAccount_y" type="text" placeholder="请再次输入支付宝账号"/>
							</div>
						</div>
						<div class="form-group">
							<label class="form-label">&nbsp;</label>
							<button class="btn btn-primary mr20" type="button" @click="PostZfb()">确认，提交</button>
							<a  href="javascript:;" class="btn btn-default" @click="dialogFormVisible = false">返回</a>
						</div>
			</div>
		</el-dialog>
		<el-dialog title="修改支付宝" :visible.sync="updZfb">
			<div class="userform" style="padding: 0;" >
				<div class="form-group mb0">
					<label class="form-label">支付宝姓名：</label>
					<div class="form-element"><strong>{{name}}</strong></div>
				</div>
						<div class="form-group">
							<label class="form-label">
								<em>*</em>
								 支付宝帐号：
							</label>
							<div class="form-element">
								<input class="form-control"  type="text" v-model="updateZfbAccount" placeholder="请输入支付宝账号"/>
								<div class="help-block">
									<p>
										请认真填写，该支付宝账户真实姓名必须与【
										<span class="text-dark">{{name}}</span>
										】身份一致！
									</p>
								</div>
							</div>
						</div>
						<div class="form-group">
							<label class="form-label">
								<em>*</em>
									确认帐号：
							</label>
							<div class="form-element">
								<input class="form-control" v-model="updateZfbAccount_y" type="text" placeholder="请再次输入支付宝账号"/>
							</div>
						</div>
						<div class="form-group">
							<label class="form-label">&nbsp;</label>
							<button class="btn btn-primary mr20" type="button" @click="PostUpdateZfb()">确认，修改</button>
							<a  href="javascript:;" class="btn btn-default" @click="updZfb = false">返回</a>
						</div>
			</div>
		</el-dialog>
		<el-dialog title="添加银行卡" :visible.sync="dialogFormVisibleBank">
				<div class="userform" style="padding: 0;" >
					<div class="form-group mb0">
						<label class="form-label">银行卡姓名：</label>
						<div class="form-element"><strong>{{name}}</strong></div>
					</div>
							<div class="form-group">
								<label class="form-label">
									<em>*</em>
									 银行卡开户行：
								</label>
								<div class="form-element">
									<input class="form-control"  type="text" v-model="addBankName" placeholder="请输入开户行"/>
									<div class="help-block">
										<p>
											请认真填写，该银行卡账户真实姓名必须与【
											<span class="text-dark">{{name}}</span>
											】身份一致！
										</p>
									</div>
								</div>
							</div>
							<div class="form-group">
								<label class="form-label">
									<em>*</em>
										银行卡卡号：
								</label>
								<div class="form-element">
									<input class="form-control" v-model="addBankNum" type="number" placeholder="请输入银行卡卡号"/>
								</div>
							</div>
							<div class="form-group">
								<label class="form-label">&nbsp;</label>
								<button class="btn btn-primary mr20" type="button" @click="PostBank()">确认，提交</button>
								<a  href="javascript:;" class="btn btn-default" @click="dialogFormVisibleBank = false">返回</a>
							</div>
				</div>
			</el-dialog>
			<el-dialog title="修改银行卡" :visible.sync="updBank">
					<div class="userform" style="padding: 0;" >
						<div class="form-group mb0">
							<label class="form-label">银行卡姓名：</label>
							<div class="form-element"><strong>{{name}}</strong></div>
						</div>
								<div class="form-group">
									<label class="form-label">
										<em>*</em>
										 银行卡开户行：
									</label>
									<div class="form-element">
										<input class="form-control"  type="text" v-model="updateBankName" placeholder="请输入开户行"/>
										<div class="help-block">
											<p>
												请认真填写，该银行卡账户真实姓名必须与【
												<span class="text-dark">{{name}}</span>
												】身份一致！
											</p>
										</div>
									</div>
								</div>
								<div class="form-group">
									<label class="form-label">
										<em>*</em>
											银行卡卡号：
									</label>
									<div class="form-element">
										<input class="form-control" v-model="updateBankNum" type="number" placeholder="请输入银行卡卡号"/>
									</div>
								</div>
								<div class="form-group">
									<label class="form-label">&nbsp;</label>
									<button class="btn btn-primary mr20" type="button" @click="PostUpdateBank()">确认，修改</button>
									<a  href="javascript:;" class="btn btn-default" @click="updBank = false">返回</a>
								</div>
					</div>
				</el-dialog>
			<el-dialog title="添加微信" :visible.sync="dialogFormVisibleWx">
					<div class="dd-skqkgf" style="" >
						<img :src="addWx"/>
						<div class="help-block">
							<p>
								请使用，【
								<span class="text-dark">{{name}}</span>
								】的微信扫描次二维码添加微信提现账号
							</p>
						</div>
					</div>
				</el-dialog>

	</div>
</template>

<script>
  import config from '@/config.js'
	export default{
		data(){
			return{
				addZfbAccount:"",
				addZfbAccount_y:"",
				addBankName:"",
				addBankNum:"",
				addWx:"",
				dialogFormVisible:false,
				dialogFormVisibleBank:false,
				dialogFormVisibleWx:false,
				updBank:false,
				updZfb:false,
				updateZfbAccount:"",
				updateZfbAccount_y:"",
				aconId:"",
				updateBankNum:"",
				updateBankName:""
			}
		},
		props:{
			name:{
				type:String,
				default:""
			}
		},
		methods:{
      getSettings(){
        return new Promise((relove,reject) => {
          this.$api.systemsettings()
          .then(result => {
            localStorage.setItem('settingPc',JSON.stringify(result))
            relove(result)
          })
        })
      },
			getQrcode(){
				let token = localStorage.getItem('token')
				this.$api.getAppid({
					token: token,
				}).then(async res => {
					let appid = res.data
          let settingPc = JSON.parse(localStorage.getItem('settingPc'))
          if(!settingPc){
            settingPc = await this.getSettings()
          }
					let url = settingPc.web_url + config.addWx +  '?appid='+appid + "&token="+token
					url = encodeURIComponent(url)
					this.$api.getJsonQrcode({
						data:url
					}).then(result => {
						let image = 'data:image/png;base64,' +result.data
						this.addWx = image
						this.dialogFormVisibleWx = true
					})
				})
			},
			PostBank(){
				if(!this.addBankName){
					this.$message({
						message: '请输入开户行名称',
						type: 'warning'
					});
					return
				}
				if(!this.addBankNum){
					this.$message({
						message: '请输入卡号',
						type: 'warning'
					});
					return
				}
				let token = localStorage.getItem('token')
				this.$api.setWithdrawBank({
					token:token,
					account:this.addBankNum,
					bank_name:this.addBankName,
				}).then(res => {
					if(res.code === 1){
						this.$message({
							message: res.msg,
							type: 'success'
						});
						this.addBankName = ""
						this.addBankNum = ''
						setTimeout(() => {
							window.location.reload();
						},500)
					}else{
						this.$message({
							message: res.msg,
							type: 'warning'
						});
					}
				})
			},
			PostUpdateBank(){
				if(!this.updateBankName){
					this.$message({
						message: '请输入开户行名称',
						type: 'warning'
					});
					return
				}
				if(!this.updateBankNum){
					this.$message({
						message: '请输入卡号',
						type: 'warning'
					});
					return
				}
				let token = localStorage.getItem('token')
				this.$api.upWithdrawBank({
					id:this.aconId,
					account:this.updateBankNum,
					bank_name:this.updateBankName,
					token: token,
				}).then(res => {
					if(res.code === 1){
						this.$message({
							message: res.msg,
							type: 'success'
						});
						setTimeout(() => {
							window.location.reload();
						},500)
					}else{
						this.$message({
							message: res.msg,
							type: 'warning'
						});
					}
				})
			},
			PostUpdateZfb(){
				if(!this.updateZfbAccount){
					this.$message({
						message: '请输入账号',
						type: 'warning'
					});
					return
				}
				if(!this.updateZfbAccount_y){
					this.$message({
						message: '请输入确认账号',
						type: 'warning'
					});
					return
				}
				if(this.updateZfbAccount != this.updateZfbAccount_y){
					this.$message({
						message: '两次账号输入不一致',
						type: 'warning'
					});
					return
				}
				let token = localStorage.getItem('token')
				this.$api.upWithdrawAli({
					token: token,
					id:this.aconId,
					account:this.updateZfbAccount
				}).then(res => {
					if(res.code === 1){
						this.$message({
							message: res.msg,
							type: 'success'
						});
						setTimeout(() => {
							window.location.reload();
						},500)
					}else{
						this.$message({
							message: res.msg,
							type: 'warning'
						});
					}
				})
			},
			PostZfb(){
				if(!this.addZfbAccount){
					this.$message({
						message: '请输入账号',
						type: 'warning'
					});
					return
				}
				if(!this.addZfbAccount_y){
					this.$message({
						message: '请输入确认账号',
						type: 'warning'
					});
					return
				}
				if(this.addZfbAccount != this.addZfbAccount_y){
					this.$message({
						message: '两次账号输入不一致',
						type: 'warning'
					});
					return
				}
				let token = localStorage.getItem('token')
				this.$api.setWithdrawAli({
					token:token,
					account:this.addZfbAccount,
				}).then(res => {
					if(res.code === 1){
						this.$message({
							message: res.msg,
							type: 'success'
						});
						this.addZfbAccount = ""
						this.addZfbAccount_y = ''
						setTimeout(() => {
							window.location.reload();
						},500)
					}else{
						this.$message({
							message: res.msg,
							type: 'warning'
						});
					}
				})
			},
			updateBank(item){
				this.aconId = item.id
				this.updateBankNum = item.account
				this.updateBankName = item.bank_name
				this.updBank = true
			},
			updateZfb(item){
				this.aconId = item.id
				this.updateZfbAccount = item.account
				this.updateZfbAccount_y = item.account
				this.updZfb = true
			},
			addZfb(){
				this.dialogFormVisible = true
			},
			addBank(){
				this.dialogFormVisibleBank = true
			}
		}
	}
</script>

<style>
	.el-message-box{
		min-width: 500px;
	}
	.dd-skqkgf{
		text-align: center;
	}
	.dd-skqkgf img{
		width: 200px;
		height: 200px;
	}
</style>



// WEBPACK FOOTER //
// src/components/common/withdraw/pop.vue